export const randomWall = `\
-- random
-- stretchers with randomized width, no stagger

@jitter 2

S
`
